export enum LinkInfoType {
  Truck = 'TRUCK',
  Ship = 'SHIP',
  Plane = 'PLANE',
  Warning = 'WARNING',
}

export enum MilestoneType {
  Plane = 'PLANE',
  Harbour = 'HARBOUR',
}

export enum MilestoneBubbleType {
  Solid = 'SOLID',
  HalfSolid = 'HALF_SOLID',
  Empty = 'EMPTY',
}
